import {
    Box,
    Input,
    InputGroup,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from "@chakra-ui/react";
import React, { useState, useEffect, useMemo } from "react";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { createHospitalData, getDistanceFromLatLonInKm } from "../../Actions/beneficiaryDetails.action";
import { ShowAlert } from "../../../../GlobalComponents/ShowAlert/ShowAlert";
import { fetchAutoSuggestedHospitalByHttp, fetchLatAndLongHttp, updateBeneficiaryAddress } from "../../../../http";
import debounce from "lodash.debounce";

type Address = {
    location: any;
    _id: any;
    city: string
    // Define the type for your address here
};

const FindHospital: React.FC<{
    closeModal: () => void;
    addresses: Address[];
    data: any;
    selectedAddress: Address;
    setData: (data: any) => void;
}> = ({
    closeModal,
    data,
    selectedAddress,
}) => {
        const [showDropdown, setShowDropdown] = useState(false);
        const [lat, setLat] = useState<string>("");
        const [lng, setLng] = useState<string>("");
        const [hospitalAddress, setHospitalAddress] = useState<string>("");
        const [hospitalName, setHospitalName] = useState<string>("");
        const [cityName, setCityName] = useState<string>(selectedAddress.city || "");
        const [keyword, setKeyword] = useState<string>("");

        const [autoCompleteSuggestions, setAutoCompleteSuggestions] = useState<any[]>([]);
        const initialRef = React.useRef(null);
        const finalRef = React.useRef(null);
        const navigate = useNavigate();

        const handleSelectHospital = async (suggestion: any) => {
            const placeId = suggestion.place_id;
            // const service = new window.google.maps.places.PlacesService(document.createElement("div"));
            //getting hospital data again with place id for formatted address
            let response = await fetchLatAndLongHttp(placeId)
            if (response.data && response.data?.results[0]) {
                const location = response.data?.results[0]?.navigation_points[0]?.location
                const formatted_address = response.data?.results[0]?.formatted_address
                setKeyword(suggestion.description);
                setHospitalAddress(formatted_address);
                setHospitalName(suggestion.structured_formatting.main_text);
                setLat(location.latitude?.toString());
                setLng(location.longitude?.toString());
                setShowDropdown(false);
            }

            // service.getDetails(
            //     { placeId: placeId, fields: ["geometry.location"] },
            //     (place, status) => {
            //         if (status === "OK" && place && place.geometry && place.geometry.location) {
            //             console.log("🚀 ~ handleSelectHospital ~ place:", place)
            //             // Hide the dropdown after selecting a hospital
            //         } else {
            //             // Handle error or show a message that details couldn't be fetched
            //         }
            //     }
            // );
        };

        // const handleAutoComplete = async (keyWord: string) => {
        //     setShowDropdown(true);
        //     // const service = new window.google.maps.places.AutocompleteService();
        //     // const request = {
        //     //     input: cityName + "" + keyWord,
        //     //     types: ["hospital"], // Restrict the results to hospitals
        //     // };
        //     let response = await fetchAutoSuggestedHospitalByHttp(keyWord, cityName)
        //     setAutoCompleteSuggestions(response.data || []);
        //     // service.getPlacePredictions(request, (predictions) => {
        //     //     setAutoCompleteSuggestions(predictions || []);
        //     // });
        // };

        const debouncedFetch = useMemo(
            () =>
                debounce(async (keyWord: string) => {
                    try {
                        setShowDropdown(true);
                        const response = await fetchAutoSuggestedHospitalByHttp(keyWord, cityName);
                        setAutoCompleteSuggestions(response.data || []);
                    } catch (e) {
                        setAutoCompleteSuggestions([]);
                    }
                }, 400),
            [cityName]
        );

        useEffect(() => {
            return () => {
                debouncedFetch.cancel();
            };
        }, [debouncedFetch]);

        const handleAutoComplete = (keyWord: string) => {
            debouncedFetch(keyWord);
        };

        const updatePreferredHospital = async (hospital: any) => {

            try {
                await updateBeneficiaryAddress(data._id, {
                    _id: selectedAddress._id,
                    preferredHospital: [hospital],
                }
                )
                ShowAlert("success", "Preferred Hospital Saved Successfully!");
                setTimeout(() => {
                    navigate(`/profile/view/${data._id}`);
                }, 1500);
            } catch (error: any) {
                if (error?.response?.data?.message) {
                    if (Array.isArray(error.response.data.message)) {
                        return ShowAlert("warning", error.response.data.message[0]);
                    }
                }
                console.log(error, "error")
                ShowAlert("warning", "Something went wrong, please try again later 1");
            }
        }

        const handleSave = async () => {

            if (!hospitalName) {
                return updatePreferredHospital({
                    id: "0",
                    hospitalName: keyword,
                    distance: "Not Available",
                })
            }

            const hospitalPayload = {
                name: hospitalName || keyword,
                contacts: [],
                address: hospitalAddress || cityName,
                location: {
                    type: "Point",
                    coordinates: [
                        Number(lng || 0),
                        Number(lat || 0)
                    ]
                }
            }

            try {

                let distance;
                if (selectedAddress?.location && selectedAddress?.location) {
                    distance = getDistanceFromLatLonInKm(selectedAddress?.location[0]?.latitude, selectedAddress?.location[0]?.longitude, Number(lat), Number(lng));
                }

                let hospitalData = await createHospitalData(hospitalPayload);
                let hospitalPayLoad = {
                    id: hospitalData._id,
                    hospitalName: hospitalData.name,
                    distance: distance?.toFixed(2) || "Not Available",
                }
                await updatePreferredHospital(hospitalPayLoad);
            } catch (error: any) {
                if (error?.response?.data?.message) {
                    if (Array.isArray(error.response.data.message)) {
                        return ShowAlert("warning", error.response.data.message[0]);
                    }
                }
                ShowAlert("warning", "Something went wrong, please try again later 0");
                console.log(error, "error")
            }

        };

        return (
            <div>
                <Modal
                    initialFocusRef={initialRef}
                    finalFocusRef={finalRef}
                    isOpen={true}
                    onClose={closeModal}
                >
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Add New Hospital</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            <Text>City Name</Text>
                            <InputGroup>
                                <Input
                                    value={cityName}
                                    onChange={(e) => {
                                        setCityName(e.target.value);
                                        setKeyword("");
                                        setHospitalAddress("");
                                        setHospitalName("");
                                        setLat("");
                                        setLng("");
                                    }}
                                    marginBottom={"10px"}
                                    placeholder="Enter City Name"
                                    size="md"
                                />
                            </InputGroup>
                            <Text>Hospital Name</Text>
                            <InputGroup>
                                <Input
                                    isDisabled={!cityName}
                                    value={keyword}
                                    onChange={(e) => {
                                        setKeyword(e.target.value);
                                        handleAutoComplete(e.target.value);
                                    }}
                                    marginBottom={"10px"}
                                    placeholder="Enter Hospital Name"
                                    size="md"
                                />
                            </InputGroup>

                            {showDropdown &&
                                autoCompleteSuggestions.length > 0 && (
                                    <Box>
                                        {autoCompleteSuggestions.map((suggestion) => (
                                            <Box
                                                key={suggestion.place_id}
                                                onClick={() => {
                                                    handleSelectHospital(suggestion);
                                                }}
                                                p={2}
                                                cursor="pointer"
                                                _hover={{ bg: "gray.100" }}
                                            >
                                                {suggestion.description}
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                        </ModalBody>

                        <ModalFooter>
                            <Button isDisabled={!keyword.trim() || !cityName.trim()} onClick={handleSave} bgColor={"#38a169"} color={"white"} mr={3}>
                                Save
                            </Button>
                            <Button onClick={closeModal}>Cancel</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </div>
        );
    };


export default FindHospital;
